
document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[data-carousel]').forEach(function(carousel){
    const slides=[...carousel.querySelectorAll('[data-slide]')];
    const dots=[...carousel.querySelectorAll('[data-dot]')];
    const prev=carousel.querySelector('[data-prev]');
    const next=carousel.querySelector('[data-next]');
    let current=0, timer;
    const delay=Number(carousel.dataset.delay || 6500);

    function show(i){
      current=(i+slides.length)%slides.length;
      slides.forEach((s,n)=> n===current ? s.removeAttribute('hidden') : s.setAttribute('hidden','hidden'));
      dots.forEach((d,n)=>d.classList.toggle('is-active',n===current));
    }
    function autoplay(){
      clearInterval(timer);
      if(slides.length>1) timer=setInterval(()=>show(current+1),delay);
    }
    prev?.addEventListener('click',()=>{show(current-1);autoplay()});
    next?.addEventListener('click',()=>{show(current+1);autoplay()});
    dots.forEach((d,n)=>d.addEventListener('click',()=>{show(n);autoplay()}));
    show(0); autoplay();
  });
});







/* V9 — Seamless infinite Shop by Category carousel */
document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[data-category-carousel]').forEach(function(carousel){
    const viewport = carousel.querySelector('[data-category-viewport]');
    const track = carousel.querySelector('[data-category-track]');
    const prev = carousel.querySelector('[data-category-prev]');
    const next = carousel.querySelector('[data-category-next]');
    if(!viewport || !track) return;

    const originals = Array.from(track.children);
    if(originals.length < 2) return;

    // Duplicate the category set on both sides.
    originals.forEach(el => {
      const clone = el.cloneNode(true);
      clone.setAttribute('aria-hidden','true');
      track.appendChild(clone);
    });
    [...originals].reverse().forEach(el => {
      const clone = el.cloneNode(true);
      clone.setAttribute('aria-hidden','true');
      track.insertBefore(clone, track.firstChild);
    });

    let timer = null;
    let interacting = false;
    let resetting = false;

    function cardStep(){
      const card = track.querySelector('.category-card');
      const style = getComputedStyle(track);
      const gap = parseFloat(style.columnGap || style.gap || 0);
      return card ? card.getBoundingClientRect().width + gap : 180;
    }

    function setWidth(){
      return originals.length * cardStep();
    }

    function centerOnOriginals(behavior='auto'){
      viewport.scrollTo({left:setWidth(), behavior});
    }

    function normalize(){
      if(resetting) return;
      const width = setWidth();
      if(width <= 0) return;

      if(viewport.scrollLeft >= width * 2 - 2){
        resetting = true;
        viewport.scrollLeft -= width;
        requestAnimationFrame(()=> resetting=false);
      } else if(viewport.scrollLeft <= 2){
        resetting = true;
        viewport.scrollLeft += width;
        requestAnimationFrame(()=> resetting=false);
      }
    }

    function move(dir){
      viewport.scrollBy({left:dir * cardStep(), behavior:'smooth'});
    }

    function start(){
      stop();
      timer = setInterval(function(){
        if(!interacting) move(1);
      }, 4300);
    }

    function stop(){
      if(timer){ clearInterval(timer); timer=null; }
    }

    prev?.addEventListener('click', function(){ move(-1); start(); });
    next?.addEventListener('click', function(){ move(1); start(); });

    viewport.addEventListener('scroll', function(){
      window.clearTimeout(viewport._eroniaScrollTimer);
      viewport._eroniaScrollTimer = window.setTimeout(normalize, 90);
    }, {passive:true});

    ['touchstart','pointerdown','mouseenter','focusin'].forEach(evt=>{
      viewport.addEventListener(evt, ()=>{interacting=true;stop();}, {passive:true});
    });
    ['touchend','pointerup','mouseleave','focusout'].forEach(evt=>{
      viewport.addEventListener(evt, ()=>{interacting=false;normalize();start();}, {passive:true});
    });

    window.addEventListener('resize', function(){
      centerOnOriginals('auto');
    });

    // Start at the real first category (Beds & Furniture).
    requestAnimationFrame(()=>centerOnOriginals('auto'));
    start();
  });
});

/* V15 header refinement */
document.addEventListener('scroll',function(){
  const h=document.querySelector('.site-header');
  if(h) h.classList.toggle('is-scrolled',window.scrollY>30);
},{passive:true});

/* V18 — premium interaction refinements */
document.addEventListener('DOMContentLoaded', function(){
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if(reduceMotion){
    document.querySelectorAll('[data-category-carousel]').forEach(function(carousel){
      const viewport = carousel.querySelector('[data-category-viewport]');
      if(viewport) viewport.style.scrollBehavior = 'auto';
    });
  }

  // Keep header compact and calm on scroll.
  const header = document.querySelector('.site-header');
  let lastY = window.scrollY;
  window.addEventListener('scroll', function(){
    if(!header) return;
    const y = window.scrollY;
    header.classList.toggle('is-scrolled', y > 24);
    lastY = y;
  }, {passive:true});
});


/* V46 — Quiet luxury motion system */
document.addEventListener('DOMContentLoaded', function(){
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const selectors = [
    '.section-head',
    '.product-card',
    '.pet-nav-card',
    '.category-card',
    '.why-item',
    '.story-copy',
    '.newsletter-inner',
    '.eronia-trust__item',
    '.product-info',
    '.product-gallery',
    '.collection-toolbar'
  ];

  const items = Array.from(document.querySelectorAll(selectors.join(',')));
  items.forEach((el, i) => {
    el.classList.add('eronia-reveal');
    el.style.setProperty('--reveal-delay', `${Math.min(i % 6, 5) * 55}ms`);
  });

  if(reduceMotion){
    items.forEach(el => el.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {rootMargin:'0px 0px -8% 0px', threshold:0.08});

  items.forEach(el => observer.observe(el));

  /* Gentle cinematic movement on hero imagery */
  document.querySelectorAll('.hero__slide').forEach(function(slide){
    const photo = slide.querySelector('.hero__photo');
    if(photo) photo.classList.add('eronia-cinematic');
  });

  /* Soft pointer/touch feedback on cards */
  document.querySelectorAll('.product-card, .pet-nav-card, .category-card').forEach(function(card){
    card.addEventListener('pointerdown', function(){
      card.classList.add('is-pressing');
    });
    ['pointerup','pointercancel','pointerleave'].forEach(function(evt){
      card.addEventListener(evt, function(){ card.classList.remove('is-pressing'); });
    });
  });

  /* Slight story image drift as it comes into view */
  const story = document.querySelector('.story');
  if(story){
    const storyObserver = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        story.classList.toggle('is-in-view', entry.isIntersecting);
      });
    }, {threshold:0.18});
    storyObserver.observe(story);
  }
});

/* V47 — Signature storefront interactions */
document.addEventListener('DOMContentLoaded', function(){
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Thin, unobtrusive reading progress line makes long mobile pages feel responsive.
  if(!reduce){
    const progress = document.createElement('div');
    progress.className = 'eronia-progress';
    document.body.appendChild(progress);
    const updateProgress = function(){
      const max = document.documentElement.scrollHeight - window.innerHeight;
      progress.style.width = (max > 0 ? Math.min(100, (window.scrollY / max) * 100) : 0) + '%';
    };
    window.addEventListener('scroll', updateProgress, {passive:true});
    window.addEventListener('resize', updateProgress, {passive:true});
    updateProgress();
  }

  // Make editorial interlude participate in the reveal system.
  const editorial = document.querySelector('.eronia-editorial-break__inner');
  if(editorial){
    editorial.classList.add('eronia-reveal');
    if(reduce){ editorial.classList.add('is-visible'); }
    else {
      const io = new IntersectionObserver(entries => entries.forEach(entry => {
        if(entry.isIntersecting){ entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      }), {threshold:.12});
      io.observe(editorial);
    }
  }
});


/* V48 — conversion-aware product interactions */
document.addEventListener('DOMContentLoaded', function(){
  const sticky = document.querySelector('[data-mobile-sticky-atc]');
  const original = document.querySelector('.product-purchase-row');
  if(sticky && original && 'IntersectionObserver' in window){
    const io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){ sticky.classList.toggle('is-hidden', entry.isIntersecting); });
    }, {threshold:.35});
    io.observe(original);
  }
});


/* V55 — tasteful first-session free-shipping welcome */
document.addEventListener('DOMContentLoaded', function(){
  var popup=document.querySelector('[data-eronia-welcome]');
  if(!popup) return;

  var path=window.location.pathname.toLowerCase();
  if(path.indexOf('/checkout')===0 || path.indexOf('/account')===0) return;

  var key='eronia_free_shipping_welcome_v1';
  try{
    if(sessionStorage.getItem(key)==='seen') return;
  }catch(e){}

  var timer=setTimeout(function(){
    popup.hidden=false;
    popup.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('eronia-welcome-open');
    requestAnimationFrame(function(){ popup.classList.add('is-visible'); });
    try{sessionStorage.setItem(key,'seen');}catch(e){}
    var close=popup.querySelector('.eronia-welcome__close');
    if(close) close.focus({preventScroll:true});
  },4200);

  function closeWelcome(){
    clearTimeout(timer);
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('eronia-welcome-open');
    setTimeout(function(){ popup.hidden=true; },240);
  }

  popup.querySelectorAll('[data-eronia-welcome-close]').forEach(function(el){
    el.addEventListener('click',closeWelcome);
  });

  var shop=popup.querySelector('[data-eronia-welcome-shop]');
  if(shop) shop.addEventListener('click',function(){
    try{sessionStorage.setItem(key,'seen');}catch(e){}
  });

  document.addEventListener('keydown',function(e){
    if(e.key==='Escape' && !popup.hidden) closeWelcome();
  });
});


/* V56 — hero polish helper; no structural slider changes */
document.addEventListener('DOMContentLoaded', function(){
  const hero = document.querySelector('[data-carousel]');
  if(!hero) return;

  const slides = Array.from(hero.querySelectorAll('[data-slide]'));
  const observer = new MutationObserver(function(){
    slides.forEach(function(slide){
      const img = slide.querySelector('.hero__photo img');
      if(!img) return;
      if(!slide.hasAttribute('hidden')){
        img.style.transform = 'scale(1.025)';
      }
    });
  });

  slides.forEach(function(slide){
    observer.observe(slide,{attributes:true,attributeFilter:['hidden']});
  });
});






/* V59 — premium add-to-bag confirmation */
document.addEventListener('DOMContentLoaded', function(){
  const form = document.getElementById('eronia-product-form');
  const panel = document.querySelector('[data-eronia-cart-confirm]');
  if(!form || !panel) return;

  const imageEl = panel.querySelector('[data-cart-confirm-image]');
  const titleEl = panel.querySelector('[data-cart-confirm-title-text]');
  const variantEl = panel.querySelector('[data-cart-confirm-variant]');
  const priceEl = panel.querySelector('[data-cart-confirm-price]');
  const totalEl = panel.querySelector('[data-cart-confirm-total]');

  function money(cents){
    try{
      return new Intl.NumberFormat(undefined,{style:'currency',currency:'USD'}).format((cents||0)/100);
    }catch(e){
      return '$' + ((cents||0)/100).toFixed(2);
    }
  }

  function openPanel(){
    panel.hidden = false;
    panel.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('eronia-cart-confirm-open');
    requestAnimationFrame(function(){ panel.classList.add('is-visible'); });
    const primary = panel.querySelector('.eronia-cart-confirm__primary');
    if(primary) primary.focus({preventScroll:true});
  }

  function closePanel(){
    panel.classList.remove('is-visible');
    panel.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('eronia-cart-confirm-open');
    setTimeout(function(){ panel.hidden = true; }, 240);
  }

  async function refreshCart(){
    const response = await fetch('/cart.js',{
      headers:{'Accept':'application/json'},
      credentials:'same-origin'
    });
    if(!response.ok) return null;

    const cart = await response.json();
    const bag = document.querySelector('.header-action--bag');
    if(bag){
      let count = bag.querySelector('.bag-count');
      if(cart.item_count > 0){
        if(!count){
          count = document.createElement('b');
          count.className = 'bag-count';
          bag.appendChild(count);
        }
        count.textContent = cart.item_count;
      }else if(count){
        count.remove();
      }
    }
    return cart;
  }

  form.addEventListener('submit', async function(event){
    event.preventDefault();

    const submit = form.querySelector('.product-atc');
    if(submit && submit.disabled) return;

    const originalText = submit ? submit.textContent : '';

    if(submit){
      submit.disabled = true;
      submit.classList.add('is-adding');
      submit.textContent = 'ADDING…';
    }

    try{
      const data = new FormData(form);
      const response = await fetch('/cart/add.js',{
        method:'POST',
        body:data,
        headers:{'Accept':'application/json'},
        credentials:'same-origin'
      });

      if(!response.ok){
        let msg = 'Unable to add this item.';
        try{
          const err = await response.json();
          msg = err.description || err.message || msg;
        }catch(e){}
        throw new Error(msg);
      }

      const item = await response.json();
      const cart = await refreshCart();

      if(titleEl) titleEl.textContent = item.product_title || item.title || 'Item added';
      if(variantEl){
        const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        variantEl.textContent = variant;
        variantEl.style.display = variant ? '' : 'none';
      }
      if(priceEl) priceEl.textContent = money(item.final_price || item.price);
      if(totalEl && cart) totalEl.textContent = money(cart.total_price);

      if(imageEl){
        const image = item.image || (item.featured_image && item.featured_image.url) || '';
        if(image){
          imageEl.src = image;
          imageEl.alt = item.product_title || item.title || 'Added product';
          imageEl.parentElement.style.display = '';
        }else{
          imageEl.parentElement.style.display = 'none';
        }
      }

      openPanel();

    }catch(error){
      alert(error.message || 'Unable to add this item to your bag.');
    }finally{
      if(submit){
        submit.disabled = false;
        submit.classList.remove('is-adding');
        submit.textContent = originalText;
      }
    }
  });

  panel.querySelectorAll('[data-cart-confirm-close]').forEach(function(el){
    el.addEventListener('click', closePanel);
  });

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && !panel.hidden) closePanel();
  });
});

/* V77 — signature category showcase interactions */
document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[data-category-signature]').forEach(function(section){
    const features = Array.from(section.querySelectorAll('[data-category-feature]'));
    const pills = Array.from(section.querySelectorAll('[data-category-pill]'));
    const dots = Array.from(section.querySelectorAll('[data-category-dot]'));
    if(!features.length) return;

    let current = 0;
    let timer = null;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function show(index){
      current = (index + features.length) % features.length;
      features.forEach(function(feature, i){
        const active = i === current;
        feature.classList.toggle('is-hidden', !active);
        if(active){
          feature.removeAttribute('hidden');
          feature.id = 'category-feature-' + i;
        } else {
          feature.setAttribute('hidden','hidden');
        }
      });
      pills.forEach(function(pill, i){
        const active = i === current;
        pill.classList.toggle('is-active', active);
        pill.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      dots.forEach(function(dot, i){
        dot.classList.toggle('is-active', i === current);
      });
    }

    function start(){
      if(reduceMotion || features.length < 2) return;
      stop();
      timer = setInterval(function(){ show(current + 1); }, 5200);
    }

    function stop(){
      if(timer){ clearInterval(timer); timer = null; }
    }

    pills.forEach(function(pill, i){
      pill.addEventListener('click', function(){ show(i); start(); });
    });
    dots.forEach(function(dot, i){
      dot.addEventListener('click', function(){ show(i); start(); });
    });

    ['mouseenter','focusin','touchstart','pointerdown'].forEach(function(evt){
      section.addEventListener(evt, stop, {passive:true});
    });
    ['mouseleave','focusout','touchend','pointerup'].forEach(function(evt){
      section.addEventListener(evt, start, {passive:true});
    });

    show(0);
    start();
  });
});
